import { createContext, useContext, useState, useEffect } from 'react';
import theme from '../theme';

const DarkModeContext = createContext();

// Runs synchronously at module load — before the first React render.
// Sets the dark class and CSS vars immediately so there is no flash
// of incorrect colours on page load.
// isBlog=false is a safe default; ContextApplier corrects it once mounted.
(function initTheme() {
  const stored = localStorage.getItem('darkMode');
  const isDark = stored !== null
    ? stored === 'true'
    : window.matchMedia('(prefers-color-scheme: dark)').matches;
  if (isDark) document.documentElement.classList.add('dark');
  theme.applyTheme(isDark, false);
}());

export function DarkModeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    const stored = localStorage.getItem('darkMode');
    if (stored !== null) return stored === 'true';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', dark);
    if (dark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [dark]);

  return (
    <DarkModeContext.Provider value={{ dark, toggle: () => setDark((d) => !d) }}>
      {children}
    </DarkModeContext.Provider>
  );
}

export function useDarkMode() {
  return useContext(DarkModeContext);
}
